import { render } from "./AuthCallback.vue?vue&type=template&id=6e126fb8"
const script = {}

import exportComponent from "/Users/jay/Downloads/exp/hl/msgui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__